import { Container } from "@mui/material";
import PropertyCard from "./propertyCard";
import Status from "../../components/simple/Status.js";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import Button from "components/button/BasicButton";
import { useEffect, useState } from "react";
import { MaterialUISwitch } from "components/Input/switch";
import { apiSetAlert } from "api/appApi";
import { useDispatch } from "react-redux";
import { apiAddProperty, apiEditProperty, apiGetProperty } from "api/property";
import { useNavigate, useParams } from "react-router-dom";
import { use } from "packages/swiper/swiper-bundle";
interface PropertyData {
    items: Array<{ id: string | number, value: string }>
    item: string | number
    title: string | number
    active: boolean
}
const ProductProperty = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const [value, setValue] = useState<PropertyData>({
        items: [],
        item: '',
        title: "",
        active: true
    })
    const dispatch = useDispatch()
    useEffect(() => {
        if (id) {
            // @ts-ignore
            dispatch(apiGetProperty({
                id, cb: (res: any) => {
                    setValue(state => {
                        return { ...state, title: res.data.fa_title, active: res.data.isActive, items: res.data.Product_Property_Items.map((x: { id: number, fa_title: string }) => { return { id: x.id, value: x.fa_title } }) }
                    })
                }
            }))
        }
        return () => {

        }
    }, [])
    const removeItem = (item: { id: string | number, value: string }) => {
        const ix = value.items.findIndex(x => x.id === item.id && x.value === item.value)
        if (ix > -1) {

            setValue(state => {
                const items = [...state.items]
                items.splice(ix, 1)
                return { ...state, items }
            })
        }
    }
    const addProperty = () => {
        const data = {
            productProperty: { fa_title: value.title, isActive: value.active },
            productPropertyItems: value.items.map(x => { return { id: null, fa_title: x.value } })
        }
        //@ts-ignore
        dispatch(apiAddProperty({
            data, cb: () => {
                navigate("/productsproperty")
            }
        }))
    }
    const propertyEdit = () => {
        const data = {
            productProperty: { fa_title: value.title, isActive: value.active },
            productPropertyItems: value.items.map(x => { return { id: x.id === "new" ? null : x.id, fa_title: x.value } })
        }
        //@ts-ignore
        dispatch(apiEditProperty({
            data, cb: () => {
                navigate("/productsproperty")

            }, id
        }))
    }
    return (
        <Container maxWidth="lg">
            <div className="wrap-add-product">
                <div className="flex fle-row justify-between items-center mt-2 ">
                    <div className="right-title-product">
                        <div className="text-xl font-IRANSansMedium">افزودن ویژگی محصول</div>
                        <div className="text-sm font-IRANSans mt-1"></div>
                    </div>
                    <a className="flex flex-row text-gray-400" href="/productsproperty" >
                        <img className="img-left-title-product" src="/static/media/arrow-back-list.0b9571f70c4abb7bb616c3cb40741358.svg" />بازگشت</a>
                </div>
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-4 mt-0 css-480o17-MuiGrid-root">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12 MuiGrid-grid-md-12 MuiGrid-grid-lg-8 MuiGrid-grid-xl-8 css-1hjr3y7-MuiGrid-root">
                        <div className="body-inputs-page">
                            <div className="header-inputs-page">
                                <div className="text-header-inputs">ویژگی</div>
                            </div>
                            <div className="content-inputs-page row bg-white">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 style-class-box-inputs flex">
                                            <div className="col-lg-4 col-md-4 col-sm-4 style-class-box-inputs flex flex-col place-content-center gap-4 mt-[5px]">
                                                <BasicTextInput val={value.title} label="عنوان فارسی" onChange={(val) => {
                                                    setValue(state => { return { ...state, title: val } })
                                                }} />
                                                <div className="flex place-content-center ">
                                                    <Status onChange={(val: boolean) => {
                                                        setValue(state => {
                                                            return { ...state, active: val }
                                                        })
                                                    }} input={{ defaultValue: true }} />

                                                </div>
                                                {/* <BasicTextInput label="عنوان انگلیسی" /> */}

                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 style-class-box-inputs mt-2">
                                                <span>آیتم های ویژگی</span>
                                                <div className="border-slate-300 border p-3 rounded-md  flex flex-col h-44 gap-2 overflow-y-auto max-h-44 mt-2">
                                                    {
                                                        value.items.map((item, ix) => {

                                                            return (<div key={ix} className="hover:bg-blue-5 p-2 flex justify-between rounded-md">
                                                                <span>{item.value}</span>
                                                                <span onClick={() => { removeItem(item) }} className="text-red-800 cursor-pointer">X</span>
                                                            </div>)
                                                        })
                                                    }




                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 style-class-box-inputs place-content-center flex flex-col gap-14">
                                                <BasicTextInput label="آیتم" val={value.item} onChange={(val) => {
                                                    setValue(state => { return { ...state, item: val } })
                                                }} required />
                                                <Button onClick={() => {
                                                    setValue(state => {
                                                        if (state.item !== "") {
                                                            const items = [...state.items]
                                                            if (items.findIndex(x => x.value.trim().toLowerCase() === state.item) === -1) {
                                                                items.push({ id: 'new', value: state.item.toString() })
                                                                return { ...state, item: "", items }
                                                            } else {
                                                                // @ts-ignore
                                                                dispatch(apiSetAlert("آیتم مورد نظر تکراری می باشد", "warning"));

                                                                return state
                                                            }

                                                        } else {
                                                            // @ts-ignore
                                                            dispatch(apiSetAlert("فیلد آیتم راپر نمایید", "warning"));
                                                            return state
                                                        }

                                                    })
                                                }} variant="secondary">اضافه کردن آیتم</Button>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12  float-left  flex flex-row-reverse mt-4 ">
                                <div className="col-md-4">

                                    <Button style={{ width: "100%" }} variant="primary" onClick={() => {
                                        if (id) {
                                            return propertyEdit()
                                        }
                                        addProperty()
                                    }} className="w-full text-white">{id ? "ویرایش ویژگی" : "ذخیره ویژگی"}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </Container >
    );
}

export default ProductProperty;